import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { LanguageContext } from '../translations/LanguageContext';

function Navbar() {
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const { language, setLanguage, translations } = useContext(LanguageContext);
  const navText = translations[language].navbar;

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
    setShowLanguageMenu(false);
  };

  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src="/assets/Me.png" alt="Home" className="navbar-logo-img" />
      </Link>
      <div className="navbar-links">
        <Link to="/about">{navText.about}</Link>
        <Link to="/contact">{navText.contact}</Link>

        <div className="language-selector">
          <button className="language-button" onClick={() => setShowLanguageMenu(!showLanguageMenu)}>
            {navText.language}
          </button>
          {showLanguageMenu && (
            <div className="language-menu">
              <button onClick={() => handleLanguageSelect('en')}>English</button>
              <button onClick={() => handleLanguageSelect('de')}>Deutsch</button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
